import moment from "moment-timezone";
import React, { useEffect, useRef, useState } from "react";

const budapest = moment().tz("Europe/Budapest");
const timeLimit = moment().tz("Europe/Budapest").add(24, 'hours').unix();

export default function CountDown({ initialCountDown: initialTimestamp }) {
    let [countDown, setCountDown] = useState((+initialTimestamp - budapest.unix()));
    const interval = useRef(null);

    const hours = Math.floor(countDown / 3600)
        .toString()
        .padStart(2, "0");
    const minutes = Math.floor((countDown - Math.floor(countDown / 3600) * 3600) / 60)
        .toString()
        .padStart(2, "0");
    const seconds = (
        countDown -
        Math.floor((countDown - Math.floor(countDown / 3600) * 3600) / 60) * 60 -
        Math.floor(countDown / 3600) * 3600
    )
        .toString()
        .padStart(2, "0");

    useEffect(() => {
        const initialCountDown = (+initialTimestamp - budapest.unix());

        if (!interval.current) {
            if (+initialCountDown > 0) {
                interval.current = setInterval(() => {
                    setCountDown((val) => val - 1);
                }, 1000);
            }
        }

        return () => {
            if (interval.current) {
                clearInterval(interval.current);
                interval.current = null;
            }
        };
    }, [initialTimestamp, interval]);

    if(initialTimestamp > timeLimit)
        return null;

    return (
        <div
            className={
                "cart-list-item__label  cart-list-item__label--4 cart-list-item__label--countdown"
            }
        >
            <div className="cart-list-item__label__text">
                {hours}:{minutes}:{seconds}
            </div>
        </div>
    );
}
